Auth = require 'app/scripts/db/auth'
SimpleTest = require('app/common/lib/experiments/simple-test').default
{ memberId } = require('@trello/session-cookie')
getAudienceDefinitions = require('app/common/lib/experiments/audience-definitions').default

testCache = {}
getMember = -> if me = Auth.me() then me.toJSON() else null
audienceDefinitions = getAudienceDefinitions(getMember)
simpleTest = new SimpleTest(audienceDefinitions)

module.exports = (testName, identifier) ->
  identifier = identifier or memberId or 'notLoggedIn'
  key = [testName, identifier].filter((a) -> a).join(':')
  testCache[key] ?= simpleTest.getParams(testName, identifier)
